import { render } from "./ORG_UPDATE_NAME.vue?vue&type=template&id=2b735ff6"
import script from "./ORG_UPDATE_NAME.vue?vue&type=script&lang=js"
export * from "./ORG_UPDATE_NAME.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__